export const SAVE_SUCCESS_MSG = `저장된 동영상에 추가됨`;
export const SAVE_CANCEL_SUCCESS_MSG = `저장된 동영상에서 삭제됨`;
export const DELETE_SUCCESS_MSG = `동영상이 삭제됨`;
export const TO_WATCH_SUCCESS_MSG = `볼 동영상에 추가됨`;
export const WATCHED_SUCCESS_MSG = `본 동영상에 추가됨`;
export const LIKED_SUCCESS_MSG = `좋아요 표시한 동영상에 추가됨`;
export const LIKE_CANCEL_SUCCESS_MSG = `좋아요 표시한 동영상에서 삭제됨`;
export const EXCEEDED_STORABLE_VIDEOS_MSG = `저장 가능한 최대 동영상 개수 초과됨`;
